import React from 'react';
import {ALIGN, Image, View} from '@lookiero/aurora';
import {ConfigurationApplication} from '@application/Config';

interface LogoImageProps {
  light?: boolean;
  width: number;
}

const LOGO_DARK_URL = `${ConfigurationApplication.retrieve().cdnPath}/commons/logo/v1/logo_dark@2x.png`;
const LOGO_LIGHT_URL = `${ConfigurationApplication.retrieve().cdnPath}/commons/logo/v1/logo_light@2x.png`;

export const LogoImage: React.FC<LogoImageProps> = ({light, width}) => (
  <View justifyContent={ALIGN.CENTER} alignContent={ALIGN.CENTER} style={{height: 48}}>
    <Image src={light ? LOGO_LIGHT_URL : LOGO_DARK_URL} resizeMode="contain" style={{width, height: 20}} />
  </View>
);
